import { LoadingPage, Sidebar } from '@/components/common';
import { signOutUser } from '@/libs/firebase';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import authReducer from '@/redux/reducers/authReducer';
import userReducer from '@/redux/reducers/userReducer';
import { clearSavedToken } from '@/utils/auth';
import { UserType } from '@/utils/constant';
import { styled } from '@mui/material';
import { get } from 'lodash';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

export const Wrapper = styled('div')(({ theme }) => ({
  minWidth: '100vw',
  minHeight: '100vh',
  backgroundColor: '#000',
  display: 'flex',
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
  },
}));

export const SidebarContainer = styled('div')(({ theme }) => ({
  backgroundColor: '#000',
  width: '100%',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
}));

export const Content = styled('div', { name: 'Content' })(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flex: '1 0',
  padding: '30px 24px',
  margin: '0px',
  backgroundColor: '#000',
  color: '#999',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    margin: '0 64px',
    padding: '64px 0px',
  },
  [theme.breakpoints.up('lg')]: {
    width: '100%',
    maxWidth: '768px',
    margin: '0 auto',
    padding: '64px 0px 64px 0px',
  },
  [theme.breakpoints.up('xl')]: {
    padding: '64px 0px 64px 0px',
  },
  [theme.breakpoints.up('xxl')]: {
    padding: '96px 0px 96px 0px',
  },
}));

export const KYCLayout = ({ disabledAuthen }: { disabledAuthen?: boolean }) => {
  const userInfo = useAppSelector((state: any) => get(state, 'user.userInfo'));
  const isLoading = useAppSelector((state: any) => state.loading);
  const dispatch = useAppDispatch();
  const userType = useAppSelector((state: any) => state.user.userType);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (disabledAuthen) return;
    let tempUserType = null;
    const searchParams = new URLSearchParams(window.location.search);
    const forceLogin = searchParams.get('forceLogin');
    tempUserType = userType;
    if (location.pathname === '/session-validate') {
      if (userType === UserType.CONCIERGE_PORTAL) {
        navigate(
          `/?token=${userInfo.tokenCP}${location.search?.length ? `&${location.search.slice(1)}` : ''}&forceLogin=true`,
        );
        return;
      }
      navigate(`/register${location.search.length ? location.search + '&' : '?'}forceLogin=true`);
      return;
    }

    if (userType == null && !tempUserType) {
      navigate('/404');
      return;
    }

    if (location.pathname === '/register' && forceLogin) {
      clearSavedToken();
      signOutUser();
      dispatch(authReducer.actions.clearAuth());
      dispatch(userReducer.actions.clearUserInfo());
      dispatch(userReducer.actions.updateUserType(tempUserType));
      dispatch({ type: 'RESET_STEP' });
      navigate(`/register${location.search}`);
      return;
    }

    if ((!localStorage.getItem('kyc_token') || !localStorage.getItem('kyc_id')) && location.pathname !== '/register') {
      navigate('/register?forceLogin=true');
      return;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <Wrapper className="fs-unmask">
      <Helmet>
        <meta name="theme-color" content="#000" />
        <style>{'body { background-color: #000 !important; }'}</style>
      </Helmet>
      {isLoading ? <LoadingPage /> : null}
      <SidebarContainer>
        <Sidebar>
          <Content>
            <Outlet />
          </Content>
        </Sidebar>
      </SidebarContainer>
    </Wrapper>
  );
};
